export const deliveryMethodTypeInputName = 'delivery_method_type'
